import React, { useState, useContext, useEffect } from 'react';
import { ChangeEvent } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { IDSConfig } from '@state/dsconfig/types';
import { IBrandDefinition } from '@state/dsconfig/types';
import { findElementById } from "@utils/editor";
import {IColorOverlay, IShapeCircleAttributes, IShapeEllipseAttributes, IShapeRectangleAttributes, IShapeTriangleAttributes, ITextAttributes} from 'routes/private/Editor/types';
import addColor from 'assets/pngs/addColor.png';
import {findOEM,hasAtLeastOneElementType, findCommonAttributeValue} from '@utils/editor';
import ColorGenerator from 'components/ColorGenerator';
import '../ColorPicker/colorgenstyles.css'
import Input from '@components/Input';
import C from '@assets/themes/colors';
import actions from '@state/actions';
import { hexFormat } from '@utils/colors';
import {getSelectedColor} from 'utils/colors';

import Slider, { Range } from 'rc-slider';

const EditImagePicker:React.FC<IProps> = (props) => {      
    let context = useContext(Context);
    
    const [alpha, setAlpha] = useState<number>(0)
    const [hexColor, setHexColor] = useState<string>()
    const [save, setSave]= useState<boolean>(false)

    const startSlider = 0;
    const minSlider = 0;
    const maxSlider = 100;

    useEffect(() => {        
        if (!hasAtLeastOneElementType(context.editorStatus.selectedElementsId, context.data, "Image")) {
            context.onShowPicker(undefined);
        }
        else{
        const coloroverlay = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "colorOverlay", "Image");
            setColorOverlay(coloroverlay);            
        }
        
    }, [context.editorStatus.selectedElementsId, context.editorStatus.selectedElementsId.length]);

    function rgb2hex(red:number, green:number, blue:number){        
        return "#"+("0" + Math.trunc(red).toString(16)).slice(-2) + ("0" + Math.trunc(green).toString(16)).slice(-2) + ("0" + Math.trunc(blue).toString(16)).slice(-2);
    }



      
    useEffect(()=>{        
        if (hexColor!="")
        {
            let colorOverlay = getColorOverlay();
            context.onCommandChange("colorOverlay",colorOverlay,undefined,undefined,true);                            
        }
    },[hexColor])

    useEffect(()=>{                      
        if (hexColor!="" && save)
        {
            let colorOverlay = getColorOverlay();
            context.onCommandChange("colorOverlay",colorOverlay);                            
        }        
    },[save])



       

    const setColorOverlay =(colorOverlay:any) =>{       
        if (colorOverlay!==undefined)
        {
            let color = rgb2hex(colorOverlay.red, colorOverlay.green, colorOverlay.blue)                 
            setHexColor(color)
            setAlpha(Math.round(colorOverlay.alpha*100))
        }
        else{           
            setHexColor("")
            setAlpha(0)
        }

    }

    const getColorOverlay = () => {
        let hex :any = '0x' + hexColor?.replace("#","")
        let r = hex >> 16 & 0xFF
        let g = hex >> 8 & 0xFF
        let b = hex & 0xFF
        return {
            red:r,
            green:g,
            blue:b,
            alpha: (alpha/100)
        } 
    }

    const handleColorGeneratorChange = (e : any) => {                
        setHexColor(e);       
    }

    const handleAlphaChange=(e:any, notsave?:boolean) => {
        setAlpha(e);        
        let colorOverlay = getColorOverlay();
        colorOverlay.alpha = e/100;
        context.onCommandChange("colorOverlay",colorOverlay, undefined, undefined, notsave);        
    }
    const handleInputSlider = (e: any, id?:string) => {
        const inputText = e.target.value;    
        if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minSlider && parseFloat(inputText)>=Math.trunc(maxSlider))) {
            setAlpha(0);        
            let colorOverlay = getColorOverlay();
            colorOverlay.alpha = 0;
            context.onCommandChange("colorOverlay",colorOverlay);        
        }
    
        if(!isNaN(inputText) && parseFloat(inputText)>=minSlider && parseFloat(inputText)<=maxSlider) {
            setAlpha(inputText);        
            let colorOverlay = getColorOverlay();            
            colorOverlay.alpha = inputText / 100;            
            context.onCommandChange("colorOverlay",colorOverlay);           
        }
      }
    

    return (
        <S.Root>                            
            <S.optionContainer>
                <S.SliderTextContainer>
                <S.Label>
                    Color Overlay
                </S.Label>
                <S.InputSlider
                    value={alpha}
                    onChange={(e)=>handleInputSlider(e)}
                ></S.InputSlider>
                </S.SliderTextContainer>
                <S.SliderContainer>
                <Slider
                    min={minSlider}
                    max={maxSlider}
                    step={1}
                    startPoint={startSlider}
                    value={alpha}
                    onChange={(e)=> {handleAlphaChange(e,true);}}          
                    onAfterChange={(e)=> {handleAlphaChange(e)}}              
                    railStyle={{
                        height:1,
                        background: "#818181"
                        
                    }}
                    handleStyle={{
                        height: 10,
                        width: 10,                
                        marginTop: -4,
                        backgroundColor: "#c4c4c4",
                        border: 0
                    }}
                    trackStyle={{
                        height:1,
                        background: "none"
                    }}
                    dotStyle={{
                        border:0,
                        height:5,
                        width:5,
                        top:-2,
                        background: "#c4c4c4"

                    }}
                
                />
                </S.SliderContainer>                 
            </S.optionContainer>
            
                <S.ColorGeneratorContainer drawBox={true}>
                    <S.ColorGeneratorBox drawBox={true}>
                    <section className="colorgen" onMouseDown={()=>setSave(false)} onMouseUp={()=>setSave(true)}>
                        <ColorGenerator show={true} color={hexColor} showInputText={true} onChange={handleColorGeneratorChange}>
                        </ColorGenerator>         
                        </section>              
                    </S.ColorGeneratorBox>
                </S.ColorGeneratorContainer>                   
            
        </S.Root>
    );


}

export default EditImagePicker;